export default {
    tab: {
        home: null,
        projectDetails: null,
        settings: null
    }
}